// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"e3a77375","308":"9643b8b3","382":"8c6fd94f","420":"c9449650","566":"488fee69","676":"eac8310e","782":"fd46ba7f","986":"482af863"}[chunkId] + ".chunk.js";
};